import { MaybeRef } from '@vueuse/core'
import { ActivationTemplate } from 'sd-types/models/activation'
import { Ref, computed, inject, unref } from 'vue-demi'

export const DefaultPreviewTemplateInjectKey = 'defaultPreviewTemplate'

export function useDefaultPreviewTemplate (localDefaultPreviewTemplate?: MaybeRef<ActivationTemplate[]>): Ref<ActivationTemplate[]> {
  const template = inject<MaybeRef<ActivationTemplate[]> | undefined>(DefaultPreviewTemplateInjectKey, undefined)
  return computed(() => unref(localDefaultPreviewTemplate) ?? unref(template) ?? [])
}
